"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var UserProfileApi = /** @class */ (function (_super) {
    __extends(UserProfileApi, _super);
    function UserProfileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfileApi.prototype.userProfileAddPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsNewProfileViewModel = _a.travisBackendContactDomainViewModelsNewProfileViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/Add',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsNewProfileViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileCustomFieldsBackgroundPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel = _a.travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/CustomFields/background',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileCustomFieldsPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel = _a.travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/CustomFields',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsBulkUpdateCustomFieldsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileCustomFieldsUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userProfileCustomFieldsUserProfileIdGet');
        var headers = {};
        return this.request({
            url: '/UserProfile/customFields/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileCustomFieldsUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, travisBackendContactDomainViewModelsAddCustomFieldsViewModel = _a.travisBackendContactDomainViewModelsAddCustomFieldsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userProfileCustomFieldsUserProfileIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/CustomFields/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsAddCustomFieldsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileDelete = function (_a, opts) {
        var travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile',
            method: 'DELETE',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileDescriptionUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, travisBackendConversationDomainViewModelsUserProfileDescriptionModel = _a.travisBackendConversationDomainViewModelsUserProfileDescriptionModel;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userProfileDescriptionUserProfileIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/Description/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            body: travisBackendConversationDomainViewModelsUserProfileDescriptionModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileExportBackgroundPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/export/background',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileExportPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/export',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, sortby = _a.sortby, order = _a.order;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (sortby != null) {
            query['sortby'] = sortby;
        }
        if (order != null) {
            query['order'] = order;
        }
        return this.request({
            url: '/UserProfile',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileSearchPost = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, fields = _a.fields, channel = _a.channel, channelIds = _a.channelIds, sortby = _a.sortby, order = _a.order, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (fields != null) {
            query['fields'] = fields;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (sortby != null) {
            query['sortby'] = sortby;
        }
        if (order != null) {
            query['order'] = order;
        }
        return this.request({
            url: '/UserProfile/Search',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileSelectAllPost = function (_a, opts) {
        var status = _a.status, channel = _a.channel, channelIds = _a.channelIds, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        return this.request({
            url: '/UserProfile/SelectAll',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileTotalGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/UserProfile/Total',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileTotalPost = function (_a, opts) {
        var status = _a.status, channel = _a.channel, channelIds = _a.channelIds, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        return this.request({
            url: '/UserProfile/Total',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileUpdateUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, travisBackendContactDomainViewModelsNewProfileViewModel = _a.travisBackendContactDomainViewModelsNewProfileViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userProfileUpdateUserProfileIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/UserProfile/Update/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsNewProfileViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userProfileUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userProfileUserProfileIdGet');
        var headers = {};
        return this.request({
            url: '/UserProfile/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileActivityUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileActivityUserProfileIdGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/userprofile/activity/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileActivityUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, travisBackendMessageDomainViewModelsRemarkViewModel = _a.travisBackendMessageDomainViewModelsRemarkViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileActivityUserProfileIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/activity/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsRemarkViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileBulkImportExcelGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/userprofile/bulk-import/excel',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileBulkImportIntoListSpreadsheetBackgroundPost = function (_a, opts) {
        var listId = _a.listId, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (listId !== undefined) {
            formData.append('ListId', listId);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('Files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/bulk-import-into-list/spreadsheet/background',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileBulkImportSpreadsheetBackgroundPost = function (_a, opts) {
        var importName = _a.importName, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (importName !== undefined) {
            formData.append('ImportName', importName);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/bulk-import/spreadsheet/background',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileBulkImportSpreadsheetGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/userprofile/bulk-import/spreadsheet',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileChannelSwitchPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsSwitchMessagingChannelRequest = _a.travisBackendContactDomainViewModelsSwitchMessagingChannelRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/channel/switch',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsSwitchMessagingChannelRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileChatapiInstanceUserProfileIdPost = function (_a, opts) {
        var userProfileId = _a.userProfileId, travisBackendContactDomainViewModelsChangeChatAPIInstance = _a.travisBackendContactDomainViewModelsChangeChatAPIInstance;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileChatapiInstanceUserProfileIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/chatapi/instance/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsChangeChatAPIInstance,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileConversationUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileConversationUserProfileIdGet');
        var headers = {};
        return this.request({
            url: '/userprofile/conversation/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportExcelGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/userprofile/import/excel',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportIntoListSpreadsheetBackgroundPost = function (_a, opts) {
        var listId = _a.listId, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (listId !== undefined) {
            formData.append('ListId', listId);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('Files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/import-into-list/spreadsheet/background',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportPreviewPost = function (_a, opts) {
        var importName = _a.importName, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (importName !== undefined) {
            formData.append('ImportName', importName);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/import/preview',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportSpreadsheetBackgroundPost = function (_a, opts) {
        var importName = _a.importName, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (importName !== undefined) {
            formData.append('ImportName', importName);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/import/spreadsheet/background',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportSpreadsheetGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/userprofile/import/spreadsheet',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportSpreadsheetPost = function (_a, opts) {
        var importName = _a.importName, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (importName !== undefined) {
            formData.append('ImportName', importName);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/import/spreadsheet',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileImportValidatePost = function (_a, opts) {
        var importName = _a.importName, columnsMap = _a.columnsMap, files = _a.files, isTriggerAutomation = _a.isTriggerAutomation;
        var headers = {};
        var formData = new FormData();
        if (importName !== undefined) {
            formData.append('ImportName', importName);
        }
        if (columnsMap !== undefined) {
            formData.append('ColumnsMap', columnsMap);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (isTriggerAutomation !== undefined) {
            formData.append('IsTriggerAutomation', isTriggerAutomation);
        }
        return this.request({
            url: '/userprofile/import/validate',
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListBookmarkPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsBookmarkViewModel = _a.travisBackendContactDomainViewModelsBookmarkViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/bookmark',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsBookmarkViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListBriefGet = function (_a, opts) {
        var name = _a.name;
        var headers = {};
        var query = {};
        if (name != null) {
            query['name'] = name;
        }
        return this.request({
            url: '/userprofile/list/brief',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListCreatePost = function (_a, opts) {
        var travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/create',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListDelete = function (_a, opts) {
        var travisBackendContactDomainViewModelsGroupListViewModel = _a.travisBackendContactDomainViewModelsGroupListViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list',
            method: 'DELETE',
            headers: headers,
            body: travisBackendContactDomainViewModelsGroupListViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, name = _a.name;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (name != null) {
            query['name'] = name;
        }
        return this.request({
            url: '/userprofile/list',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListGroupIdAddBackgroundPost = function (_a, opts) {
        var groupId = _a.groupId, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(groupId, 'groupId', 'userprofileListGroupIdAddBackgroundPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/{groupId}/add/background'.replace('{groupId}', (0, runtime_1.encodeURI)(groupId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListGroupIdAddPost = function (_a, opts) {
        var groupId = _a.groupId, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(groupId, 'groupId', 'userprofileListGroupIdAddPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/{groupId}/add'.replace('{groupId}', (0, runtime_1.encodeURI)(groupId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListGroupIdGet = function (_a, opts) {
        var groupId = _a.groupId;
        (0, runtime_1.throwIfNullOrUndefined)(groupId, 'groupId', 'userprofileListGroupIdGet');
        var headers = {};
        return this.request({
            url: '/userprofile/list/{groupId}'.replace('{groupId}', (0, runtime_1.encodeURI)(groupId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListGroupIdRemovePost = function (_a, opts) {
        var groupId = _a.groupId, travisBackendContactDomainViewModelsUserProfileIdsViewModel = _a.travisBackendContactDomainViewModelsUserProfileIdsViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(groupId, 'groupId', 'userprofileListGroupIdRemovePost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/{groupId}/remove'.replace('{groupId}', (0, runtime_1.encodeURI)(groupId)),
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsUserProfileIdsViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileListReorderPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsListReorderViewModel = _a.travisBackendContactDomainViewModelsListReorderViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/list/reorder',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsListReorderViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofilePictureProfilePictureIdGet = function (_a, opts) {
        var profilePictureId = _a.profilePictureId, mode = _a.mode;
        (0, runtime_1.throwIfNullOrUndefined)(profilePictureId, 'profilePictureId', 'userprofilePictureProfilePictureIdGet');
        var headers = {};
        var query = {};
        if (mode != null) {
            query['mode'] = mode;
        }
        return this.request({
            url: '/userprofile/picture/{profilePictureId}'.replace('{profilePictureId}', (0, runtime_1.encodeURI)(profilePictureId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileShopifyAbandonedUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileShopifyAbandonedUserProfileIdGet');
        var headers = {};
        return this.request({
            url: '/userprofile/shopify/abandoned/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileShopifyOrderUserProfileIdGet = function (_a, opts) {
        var userProfileId = _a.userProfileId, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(userProfileId, 'userProfileId', 'userprofileShopifyOrderUserProfileIdGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/userprofile/shopify/order/{userProfileId}'.replace('{userProfileId}', (0, runtime_1.encodeURI)(userProfileId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileWebclientInfoWebClientUuidGet = function (_a, opts) {
        var webClientUuid = _a.webClientUuid, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(webClientUuid, 'webClientUuid', 'userprofileWebclientInfoWebClientUuidGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/userprofile/webclient/info/{webClientUuid}'.replace('{webClientUuid}', (0, runtime_1.encodeURI)(webClientUuid)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileWhatsapp360dialogSwitchChannelPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsSwitchChannelChannelRequest = _a.travisBackendContactDomainViewModelsSwitchChannelChannelRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/whatsapp360dialog/switch-channel',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsSwitchChannelChannelRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.userprofileWhatsappCloudapiSwitchChannelPost = function (_a, opts) {
        var travisBackendContactDomainViewModelsSwitchWhatsappCloudApiChannelRequest = _a.travisBackendContactDomainViewModelsSwitchWhatsappCloudApiChannelRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/userprofile/whatsapp/cloudapi/switch-channel',
            method: 'POST',
            headers: headers,
            body: travisBackendContactDomainViewModelsSwitchWhatsappCloudApiChannelRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.v2UserProfileSearchPost = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, channelIds = _a.channelIds, assignedTo = _a.assignedTo, teamId = _a.teamId, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (assignedTo != null) {
            query['assignedTo'] = assignedTo;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        return this.request({
            url: '/v2/UserProfile/Search',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    UserProfileApi.prototype.v3UserProfileSearchPost = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, status = _a.status, channel = _a.channel, channelIds = _a.channelIds, assignedTo = _a.assignedTo, teamId = _a.teamId, travisBackendCompanyDomainModelsCondition = _a.travisBackendCompanyDomainModelsCondition;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (status != null) {
            query['status'] = status;
        }
        if (channel != null) {
            query['channel'] = channel;
        }
        if (channelIds != null) {
            query['channelIds'] = channelIds;
        }
        if (assignedTo != null) {
            query['assignedTo'] = assignedTo;
        }
        if (teamId != null) {
            query['teamId'] = teamId;
        }
        return this.request({
            url: '/v3/UserProfile/Search',
            method: 'POST',
            headers: headers,
            query: query,
            body: travisBackendCompanyDomainModelsCondition,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return UserProfileApi;
}(runtime_1.BaseAPI));
exports.UserProfileApi = UserProfileApi;
